import moment from "moment";
import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { BTTimePicker } from "commonComponents/btWrappers/BTTimePicker/BTTimePicker";
import { DateDisplay } from "commonComponents/utilities/DateDisplay/DateDisplay";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IGridFilterCellRenderProps,
} from "commonComponents/utilities/Grid/GridContainer.types";

type CellType = moment.Moment | undefined;

class TimeFilterCell extends PureComponent<IGridFilterCellRenderProps<string, CellType>> {
    render() {
        const { cellValue, field, onChange } = this.props;
        return (
            <BTTimePicker<undefined>
                id={field.full}
                data-testid={field.full}
                value={cellValue || undefined}
                onChange={onChange}
            />
        );
    }
}

class TimeCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        const { cellValue } = this.props;
        return cellValue ? <DateDisplay value={cellValue} showDate={false} showTime /> : null;
    }
}

export const columnTime: IClientGridColumn<string, CellType> = {
    validationSchema: yup.mixed().validMomentDate("time"),
    columnType: GridColumnType.time,
    mapper: (serverCellResponse) => moment(serverCellResponse),
    FilterCell: TimeFilterCell,
    Cell: TimeCell,
};
